import {IdNameVersion} from '@domain/id-name-version';
import {ArticleCardItem} from '@domain/last-modified-card-object/article-card-item';
import {TextileData} from '@domain/textile-data/textile-data';
import {ColorSetTextileDataCardItem} from './color-set-textile-data-card-item';
import {ColorTextileDataCardItem} from './color-textile-data-card-item';
import {ColoredYarnSetTextileDataCardItem} from './colored-yarn-set-textile-data-card-item';
import {ColoredYarnTextileDataCardItem} from './colored-yarn-textile-data-card-item';
import {CompanyWeaveStructureTextileDataCardItem} from './company-weave-structure-textile-data-card-item';
import {CreelTextileDataCardItem} from './creel-textile-data-card-item';
import {CustomerCardItem} from './customer-card-item';
import {FinishingTemplateTextileDataCardItem} from './finishing-template-textile-data-card-item';
import {ManageWeaveStructureTextileDataCardItem} from './manage-weave-structure-textile-data-card-item';
import {ProductConfigurationTexeditCardItem} from './product-configuration-texedit-card-item';
import {SettingsCardItem} from './settings-card-item';
import {TexfabCardItem} from './texfab-card-item';
import {WeaveStructureTextileDataCardItem} from './weave-structure-textile-data-card-item';
import {WeftColoredYarnSetTextileDataCardItem} from './weft-colored-yarn-set-textile-data-card-item';
import {YarnSetTextileDataCardItem} from './yarn-set-textile-data-card-item';
import {YarnTypeTextileDataCardItem} from './yarn-type-textile-data-card-item';

type LastModified = TextileData | TexfabCardItem | CustomerCardItem | ArticleCardItem | SettingsCardItem | ProductConfigurationTexeditCardItem | IdNameVersion;

export class CardItem {
  private _lastModified: LastModified;
  private _totalCreated: number;

  public constructor(lastModified: LastModified, totalCreated: number) {
    this._lastModified = lastModified;
    this._totalCreated = totalCreated;
  }

  public get lastModified(): LastModified {
    return this._lastModified;
  }

  public get totalCreated(): number {
    return this._totalCreated;
  }

  public static machineQualityFromJSON(cardItemJSON: any): CardItem {
    return this.cardItemFromJSON(cardItemJSON);
  }

  public static yarnTypeFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new YarnTypeTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static finishingTemplateFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new FinishingTemplateTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static finishingFromJSON(cardItemJSON: any): CardItem {
    return this.cardItemFromJSON(cardItemJSON);
  }

  public static colorFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new ColorTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static creelFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new CreelTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static weaveStructureFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new WeaveStructureTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static coloredYarnSetFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new ColoredYarnSetTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static weftColoredYarnSetFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new WeftColoredYarnSetTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static colorSetFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new ColorSetTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static yarnSetFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new YarnSetTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static companyWeaveStructureFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new CompanyWeaveStructureTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static coloredYarnFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new ColoredYarnTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static manageWeaveStructureFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(cardItemJSON?.lastModified ? new ManageWeaveStructureTextileDataCardItem(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name) : null, cardItemJSON?.totalCreated);
  }

  public static weaveProductFromJSON(cardItemJSON: any): CardItem {
    return this.cardItemFromJSON(cardItemJSON);
  }

  public static groupedWeaveStructureFromJSON(cardItemJSON: any): CardItem {
    return this.cardItemFromJSON(cardItemJSON);
  }

  public static tuftProductFromJSON(cardItemJSON: any): CardItem {
    return this.cardItemFromJSON(cardItemJSON);
  }

  private static cardItemFromJSON(cardItemJSON: any): CardItem {
    return new CardItem(
      cardItemJSON?.lastModified ? new IdNameVersion(cardItemJSON.lastModified.id, cardItemJSON.lastModified.name, cardItemJSON.lastModified.version) : null,
      cardItemJSON?.totalCreated
    );
  }
}
